import React from 'react';
import { RecommendationsRequestMaker } from './recommendations-request-maker';
import { RecommendationsRequestBroker } from './recommendations-result/response-broker';
import { Requester } from './requester';
const useRecommendations = ({
  endpoint = '/gateway/api/graphql',
  contextResolver
}) => {
  /**
   * Fetch recommendations for a given context
   */
  const getRecommendations = React.useCallback((first, rerank) => {
    const recommendationRequestMaker = new RecommendationsRequestMaker(endpoint);
    const requester = new Requester(new RecommendationsRequestBroker());
    return requester.fetch(recommendationRequestMaker.makeRequest({
      contextResolver,
      first,
      rerank
    }));
  }, [contextResolver, endpoint]);
  return {
    getRecommendations
  };
};
export default useRecommendations;